import { type UseModalState, useModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

import { TimekeepingOptionsBottomSheet } from "../Dialogs/TimekeepingOptionsBottomSheet";

interface TimekeepingOptionsButtonProps {
  shiftId: string;
  workplaceId?: string;
  clockOutModalState: UseModalState;
}

export function TimekeepingOptionsButton(props: TimekeepingOptionsButtonProps) {
  const { shiftId, workplaceId, clockOutModalState } = props;

  const timekeepingOptionsModalState = useModalState();

  return (
    <>
      <IconButton
        variant="outlined"
        iconType="ellipsis"
        aria-label="Shift options"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_OPTIONS_OPENED, { shiftId });
          timekeepingOptionsModalState.openModal();
        }}
      />
      <TimekeepingOptionsBottomSheet
        modalState={timekeepingOptionsModalState}
        clockOutModalState={clockOutModalState}
        shiftId={shiftId}
        workplaceId={workplaceId}
      />
    </>
  );
}
